import React, { ChangeEvent, useEffect, useState } from "react";
import {
  Box,
  Divider,
  FormControl,
  IconButton,
  Modal,
  Paper,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import { isEmpty } from "lodash";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";

import fontWeight from "../../../styles/mui/fontWeight";
import {
  AddUserModalBox,
  AddUserModalGrid,
  FaPencilIcon,
  FaTrashCanIcon,
  FilterByHeaderStyle,
  FilterIcon,
  FilterText,
  HeaderInputFieldWidth,
  IconFilter,
  MainContainer,
} from "../style/style";
import {
  flexAllCentre,
  flexAllEnd,
  flexRow,
} from "../../../styles/mui/styles/display";
import { ButtonContained } from "../../../app/common/button";
import {
  ButtonClearStyle,
  ButtonCloseStyle,
  ButtonVerifyStyle,
  ContainerStyle,
  FaXmarkIcon,
  HorizontalDivider,
  ModalGrid,
  NoRecordsCell,
  PaginationGrid,
  StyledTableHead,
  tableCell,
  tableCellDynamic,
  tableCellDynamic2,
} from "../../../app/styles/styles";
import colors from "../../../styles/colors/colors";
import {
  NotificationDeactivateActionDispatchTypes,
  NotificationFilterBy,
  NotificationListLabel,
  NotificationUpdateActionDispatchTypes,
} from "../../../constants/User";
import { NotificationList, Notifications } from "../../../models/User";
import PaginationItem from "../../../app/common/pagination/components/PaginationItem";
import { PER_PAGE } from "../../../constants/FunctionalUtils";
import { searchNotificationListPayload } from "../../../constants/Admin";
import { Numbers } from "../../../constants/Referral";
import AddNotification from "../containers/AddNotification";
import { addDaysToDate, currentDate, getValue, isAdmin } from "../../../utils";
import { ListOptions } from "../../../models/Master";
import { FormInputDropdown } from "../../../components/FormPriorAuthReAuth/FormInputDropdown";
import { rules } from "../../../utils/validation/Validation";
import { MyAccountModel } from "../../../models/MyAccount";
import DatePicker from "../../../components/FormPriorAuthReAuth/DatePicker";
import { FieldSpacing } from "../../PriorAuthWorkFlow/styles/style";
import { FormInputText } from "../../../components/FormPriorAuthReAuth/FormInputText";
import { formatDate, formatUTCToLocal } from "../../../utils/DateTime";
import { DateFormats } from "../../../constants/Date";
import { ApplicationRoute } from "../../../constants/ApplicationUrl";

export interface PropsFromDispatch {
  postNotificationList: (payload: any) => void;
  resetStates: (actionType: string) => void;
  getNotificationTypeList: () => void;
  updateNotification: (payload: EditNotification) => void;
  deactivateNotification: (notificationId: DeactivateNotificationPayload) => void;
}
export interface DeactivateNotificationPayload {
  notificationId: number;
  deactivatedBy: string;
}
export interface PropsFromState {
  notificationListState: NotificationList | any;
  notificationType: ListOptions[];
  loggedInUser: MyAccountModel;
  updateNotificationState: any;
  deactivateNotificationState: boolean;
  notificationsState: any;
}

export interface EditNotification {
  notificationId: number;
  notificationTypeId: number;
  titleOfNotification: string;
  updatedBy: string;
  updatedOn: string;
}

type AllProps = PropsFromState & PropsFromDispatch;

const Notification: React.FC<AllProps> = ({
  postNotificationList,
  notificationListState,
  getNotificationTypeList,
  loggedInUser,
  notificationType,
  updateNotification,
  updateNotificationState,
  deactivateNotification,
  deactivateNotificationState,
  resetStates,
  notificationsState
}) => {
  const [modalFlag, setModalFlag] = useState<boolean>(false);
  const [pageNumber, setPageNumber] = useState(1);
  const [alignmentIsActive, setAlignmentIsActive] = React.useState("active");
  const methods = useForm<any>({
    defaultValues: "",
  });
  const { handleSubmit, control, setValue, getValues, watch, reset, clearErrors } = methods;
  const [disabled, setDisabled] = useState<boolean>(true);
  const [searchValueSelected, setSearchValueSelected] = useState<string>("");
  const [notificationList, setNotificationList] = useState<Notifications[]>(
    (notificationListState && notificationListState.searchResponse) || [],
  );
  const [selectedNotificationData, setSelectedNotificationData] =
    useState<Notifications | null>(null);
  const [openUpdateUserModal, setOpenUpdateUserModal] =
    useState<boolean>(false);
  const [modalDeactivateFlag, setModalDeactivateFlag] =
    useState<boolean>(false);
  const [notificationId, setNotificationId] = useState<number>(0);
  const navigate = useNavigate();

  useEffect(() => {
    const subscription = watch((_value: any, { name }: any) => {
      if (
        name === "searchBy" &&
        !isEmpty(_value.searchBy) &&
        _value.searchBy.length > 0
      ) {
        setDisabled(false);
      }

      setSearchValueSelected(getValues("searchBy"));
    });
    return () => subscription.unsubscribe();
  }, [watch]);
  const handleChangeToggle = (
    _event: React.MouseEvent<HTMLElement>,
    newAlignment: string,
  ) => {
    setAlignmentIsActive(newAlignment);
  };
  const totalRows = getValue(notificationListState, "totalRows", 0);
  const count = Math.ceil(
    totalRows ? Number(totalRows) / PER_PAGE : 1 / PER_PAGE,
  );

  const handleSearch = () => {
    handleSubmit(onSubmit)();
  };
  const handleClear = () => {
    setValue("searchBy", null);
    setValue("searchValue", "");
    reset();
    postNotificationList(searchCriteria({ filterBy: 'all' }, false, 1));
  };

  const onSubmit = (data: any) => {
    postNotificationList(searchCriteria(data, false, 1));
  };

  useEffect(() => {
    postNotificationList(
      searchCriteria(
        {
          filterBy: alignmentIsActive,
          searchBy: getValues("searchBy"),
          searchValue: validateDate(getValues("searchValue") ?? "").toString(),
        },
        false,
        1,
      ),
    );
  }, [alignmentIsActive]);

  const addButtons = () => {
    return isAdmin(loggedInUser) ? (
      <>
        <ButtonContained
          id="btnSearch"
          onClick={() => handleSearch()}
          label="Search"
          disabled={disabled}
          style={ButtonVerifyStyle}
        />
        <ButtonContained
          id="btnClear"
          onClick={() => handleClear()}
          label="Clear"
          style={ButtonClearStyle}
        />
      </>
    ) : null;
  };
  const searchCriteria = (value: any, pageFlag: boolean, page: number) => {
    setPageNumber(page);
    const temp = {
      ...searchNotificationListPayload,
      searchBy: value.searchBy,
      searchValue: validateDate(
        getValue(value, "searchValue") ?? "",
      ).toString(),
      pageNo: pageFlag ? page : 1,
      filterBy: alignmentIsActive,
    };

    return temp;
  };

  const validateDate = (value: string) => {
    let result = "";
    if (searchValueSelected === "datepublished") {
      result = formatDate(value, DateFormats.YYYY_MM_DD);
      return result;
    }
    return value;
  };

  const handlePageChange = (_e: ChangeEvent<unknown>, page: number) => {
    postNotificationList(
      searchCriteria(
        {
          searchBy: getValues("searchBy"),
          searchValue: validateDate(
            getValue(getValues(), "searchValue") ?? "",
          ).toString(),
          filterBy: alignmentIsActive,
        },
        true,
        page,
      ),
    );
  };
  useEffect(() => {
    getNotificationTypeList();
    postNotificationList(searchCriteria({
          searchBy: getValues("searchBy"),
          searchValue: validateDate(
            getValue(getValues(), "searchValue") ?? "",
          ).toString(),
          filterBy: alignmentIsActive,
        }, false, Numbers.ONE));
  }, []);

  useEffect(() => {
    if (deactivateNotificationState === true) {
      postNotificationList(searchCriteria("default", false, Numbers.ONE));
    }
  }, [deactivateNotificationState]);

  useEffect(() => {
    setNotificationList(getValue(notificationListState, "searchResponse"));
  }, [notificationListState]);

    useEffect(() => {
    if (notificationsState) {
      postNotificationList(searchCriteria("default", false, Numbers.ONE));
    }
    }, [notificationsState]);
  
  const getResult = (item: Notifications) => {
    const result =
      notificationType &&
      notificationType.find((v) => item.notificationType === v.label);
    return result ? result.value : "";
  };

  const cellRender = (
    label: any,
    flag: boolean,
    removeBorder: boolean,
    item: Notifications,
  ) => {
    return (
      <>
        <TableCell
          sx={
            flag === false
              ? tableCellDynamic(flag, removeBorder)
              : tableCellDynamic2(flag, removeBorder)
          }
        >
          {label === "action" ? (
            <IconButton
              onClick={() => {
                setSelectedNotificationData(item);
                setValue("notificationTitleUpdate", item.titleOfNotification);
                setValue("notificationTypeUpdate", getResult(item));
                setTimeout(() => {
                  clearErrors();
                  setOpenUpdateUserModal(true);
                }, 100);
              }}
            >
              <FaPencilIcon />
            </IconButton>
          ) : label === "deactivate" ? (
            <IconButton
              onClick={() => {
                setModalDeactivateFlag(true);
                setNotificationId(item.notificationId);
              }}
            >
              <FaTrashCanIcon />
            </IconButton>
          ) : (
            <Typography
              variant="subtitle1"
              fontWeight={fontWeight[5]}
              color={colors.fonts[4]}
            >
              {label}
            </Typography>
          )}
        </TableCell>
      </>
    );
  };
  const rowRender = (data: Notifications[]) => {
    return (
      <>
        {data && data.length > 0
          ? data.map((item: Notifications, index: number) => (
               <TableRow key={item.notificationId}>
                {cellRender(
                  item.titleOfNotification,
                  false,
                  data.length - 1 === index,
                  item,
                )}
                {cellRender(
                  item.notificationType,
                  false,
                  data.length - 1 === index,
                  item,
                )}
                {cellRender(
                  formatUTCToLocal(item.datePublished, DateFormats.MM_DD_YYYY),
                  false,
                  data.length - 1 === index,
                  item,
                )}
                {cellRender(
                  item.uploadedBy,
                  false,
                  data.length - 1 === index,
                  item,
                )}
                {cellRender(
                  item.deactivatedBy,
                  false,
                  data.length - 1 === index,
                  item,
                )}
                {cellRender("action", false, data.length - 1 === index, item)}
                {cellRender(
                  "deactivate",
                  false,
                  data.length - 1 === index,
                  item,
                )}
              </TableRow>
            ))
          : NoRecordFound("0")}
      </>
    );
  };

  const NoRecordFound = (id: string) => {
    return id === "0" ? (
      <TableRow>
        <TableCell align="center" colSpan={14}>
          <Typography
            variant="subtitle1"
            fontWeight={fontWeight[3]}
            color={colors.fonts[4]}
            sx={NoRecordsCell}
          >
            NO RECORDS FOUND
          </Typography>
        </TableCell>
      </TableRow>
    ) : (
      <></>
    );
  };

  const onUploadNotification = () => {
    setModalFlag(true);
  };

  const onSubmitModal = () => {
    handleSubmit(editNotification)();
  };
  const onCancel = () => {
    setOpenUpdateUserModal(false);
    setSelectedNotificationData(null);
  };
  const editNotification = (data: any) => {
    setOpenUpdateUserModal(false);
    resetStates(
      NotificationUpdateActionDispatchTypes.NOTIFICATION_UPDATE_RESET,
    );
    if (
      data &&
      (!isEmpty(data.notificationTypeUpdate) ||
        !isEmpty(data.notificationTitleUpdate))
    ) {
      updateNotification({
        notificationId: getValue(selectedNotificationData, "notificationId"),
        notificationTypeId: data.notificationTypeUpdate,
        titleOfNotification: data.notificationTitleUpdate,
        updatedBy: getValue(loggedInUser, "providerPortalUser.email"),
        updatedOn: currentDate(),
      });
    }
  };

  useEffect(() => {
    if (updateNotificationState) {
      handleClear();
      setOpenUpdateUserModal(false);
      setSelectedNotificationData(null);
    }
  }, [updateNotificationState]);

  const onSubmitDeactivateModal = () => {
    resetStates(NotificationDeactivateActionDispatchTypes.NOTIFICATION_DEACTIVATE_RESET)
    deactivateNotification({
      notificationId: notificationId,
      deactivatedBy: getValue(loggedInUser, "providerPortalUser.email")
    });
    setModalDeactivateFlag(false);
  };

  return (
    <Box>
      <Grid container>
        <Grid size={{ xs: 12 }} mt={2} mb={1} sx={flexRow}>
          <Grid container sx={FilterByHeaderStyle} ml={2}>
            <Box sx={FilterIcon} mt={1} mr={2}>
                <Stack
                  direction="row"
                  spacing={2}
                  alignItems="center"
                  marginTop={1}
                >
                  <IconFilter />
                  <Typography
                    variant="subtitle1"
                    color={colors.black[5]}
                    fontWeight={fontWeight[4]}
                  >
                    Filter by status:
                  </Typography>
                  <Grid container spacing={2}>
                    <ToggleButtonGroup
                      color="primary"
                      value={alignmentIsActive}
                      exclusive
                      onChange={handleChangeToggle}
                      aria-label="Platform"
                      sx={FilterText}
                    >
                      <ToggleButton value="active">Active</ToggleButton>
                      <ToggleButton value="all">All</ToggleButton>
                    </ToggleButtonGroup>
                  </Grid>
                </Stack>
              </Box>
            <FormControl
              variant="standard"
              fullWidth
              sx={HeaderInputFieldWidth}
            >
              <FormInputDropdown
                name="searchBy"
                control={control}
                label="Filter By :"
                list={NotificationFilterBy}
                readOnly={false}
                onChangeHandler={() => {
                  clearErrors("searchValue")
                  setValue("searchValue", "");
                }}
              />
            </FormControl>
            {searchValueSelected === "notificationtype" ? (
              <Grid size={{ xs: 4 }}>
                <FormControl variant="standard" fullWidth>
                  <FormInputDropdown
                    label="Notification Type:"
                    control={control}
                    name="searchValue"
                    list={notificationType}
                    helper={rules.notificationTypeRequired}
                    arrowDropDownIcon={false}
                  />
                </FormControl>
              </Grid>
            ) : searchValueSelected === "datepublished" ? (
              <FormControl variant="standard">
                <DatePicker
                  name="searchValue"
                  control={control}
                  label="Search"
                  helper={rules.publishedDateRequired}
                  allowFutureDate
                  maximumdate={addDaysToDate(currentDate(), 0, "day")}
                />
              </FormControl>
            ) : null}
            <Grid ml={2} pt={1.8}>{addButtons()}</Grid>
            <Grid size={{ xs: 12 }} mt={2}>
              
            </Grid>
          </Grid>
        </Grid>
        <Grid size={{ xs: 12 }}>
          <Divider sx={HorizontalDivider} />
        </Grid>
        <Grid size={{ xs: 12 }} sx={MainContainer}>
          <Grid size={{ xs: 12 }} pl={"1rem"} pb={"1rem"} mr={"1rem"}>
            <TableContainer component={Paper} sx={ContainerStyle}>
              <Table stickyHeader>
                <StyledTableHead>
                  <TableRow>
                    {NotificationListLabel.map((data: any) => (
                      <TableCell key={data.label} sx={tableCell}>
                        <Box sx={data.style?.cell}>
                          <Typography
                            color={colors.black[16]}
                            variant="body1"
                            fontWeight={fontWeight[3]}
                          >
                            {data.label}
                          </Typography>
                        </Box>
                      </TableCell>
                    ))}
                  </TableRow>
                </StyledTableHead>
                <TableBody>
                  {rowRender(notificationList ? notificationList : [])}
                </TableBody>
              </Table>
            </TableContainer>
          </Grid>
        </Grid>
        <Grid size={{ xs: 12 }} pt={1} pr={7} sx={flexAllEnd}>
          <ButtonContained
            id="btnSubmitNotification"
            onClick={() => onUploadNotification()}
            label="Upload"
            style={ButtonVerifyStyle}
          />
          <ButtonContained
            id="btnCloseNotifications"
            onClick={() => {
              navigate(ApplicationRoute.ADMIN);
            }}
            label="Cancel"
            style={ButtonCloseStyle}
          />
        </Grid>
      </Grid>
      <Grid size={{ xs: 12 }} pr={6} sx={PaginationGrid}>
        <PaginationItem
          count={count}
          page={pageNumber}
          handlePageChange={handlePageChange}
        />
      </Grid>
      {modalFlag && (
        <AddNotification modalFlag={modalFlag} setModalFlag={setModalFlag} />
      )}
      {openUpdateUserModal && (
        <Modal
          open={openUpdateUserModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={flexAllCentre}
        >
          <Box sx={AddUserModalBox(true)}>
            <Grid container mb="0.4rem">
              <Grid size={{ xs: 11.5 }}>
                <Typography
                  id="modal-modal-title"
                  fontWeight={fontWeight[6]}
                  variant="h1"
                >
                  Edit Notification
                </Typography>
              </Grid>
              <Grid size={{ xs: 0.5 }}>
                <IconButton onClick={() => onCancel()}>
                  <FaXmarkIcon />
                </IconButton>
              </Grid>
            </Grid>
            <Divider sx={HorizontalDivider} />
            <Grid
              container
              spacing={2}
              sx={{
                margin: "0 auto",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <Grid size={{ xs: 6 }} sx={FieldSpacing}>
                <FormInputText
                  control={control}
                  helper={rules.notificationTitle}
                  name={"notificationTitleUpdate"}
                  label="Title of Notification: "
                  textLength={100}
                  disabled={false}
                />
              </Grid>
                <Grid size={{ xs: 6 }} sx={FieldSpacing}>
                <FormControl variant="standard" fullWidth>
                  <FormInputDropdown
                  label="Notification Type:"
                  control={control}
                  name="notificationTypeUpdate"
                  list={notificationType}
                  helper={rules.notificationTypeRequired}
                  arrowDropDownIcon={false}
                  value={getValues("notificationTypeUpdate")}
                  onChangeHandler={(e: any) => setValue("notificationTypeUpdate", e.target.value)}
                  />
                </FormControl>
                </Grid>
            </Grid>
            <Divider sx={HorizontalDivider} />
            <Grid container sx={AddUserModalGrid}>
              <Grid size={{ xs: 12 }} sx={flexAllEnd}>
                <ButtonContained
                  id="btnEditNotification"
                  onClick={() => onSubmitModal()}
                  label="Submit"
                  disabled={false}
                  style={ButtonVerifyStyle}
                />
                <ButtonContained
                  id="btnCancelEdit"
                  onClick={() => onCancel()}
                  label="Cancel"
                  disabled={false}
                  style={ButtonCloseStyle}
                />
              </Grid>
            </Grid>
          </Box>
        </Modal>
      )}
      {modalDeactivateFlag && (
        <Modal
          open={modalDeactivateFlag}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
          sx={flexAllCentre}
        >
          <Box sx={AddUserModalBox(true)}>
            <Grid container mb="0.4rem">
              <Grid size={{ xs: 11.5 }}>
                <Typography
                  id="modal-modal-title"
                  fontWeight={fontWeight[6]}
                  variant="h1"
                >
                  Deactivate Notification
                </Typography>
              </Grid>
              <Grid size={{ xs: 0.5 }}>
                <IconButton
                  onClick={() => {
                    setModalDeactivateFlag(false);
                    setNotificationId(0);
                  }}
                >
                  <FaXmarkIcon />
                </IconButton>
              </Grid>
            </Grid>
            <Divider sx={HorizontalDivider} />
            <Box sx={ModalGrid}>
              <Typography
                variant="h2"
                fontWeight={fontWeight[4]}
                sx={{ color: colors.fonts[6] }}
              >
                Do you want to deactivate notification?
              </Typography>
            </Box>
            <Divider sx={HorizontalDivider} />
            <Grid container sx={AddUserModalGrid}>
              <Grid size={{ xs: 12 }} sx={flexAllEnd}>
                <ButtonContained
                  id="btnSubmitDeactivationRequest"
                  onClick={() => onSubmitDeactivateModal()}
                  label="Yes"
                  disabled={false}
                  style={ButtonVerifyStyle}
                />
                <ButtonContained
                  id="btnClose"
                  onClick={() => setModalDeactivateFlag(false)}
                  label="No"
                  disabled={false}
                  style={ButtonCloseStyle}
                />
              </Grid>
            </Grid>
          </Box>
        </Modal>
      )}
    </Box>
  );
};

export default Notification;
